<template>
  <GenericExplorer
    v-if="filters"
    :filters="filters"
    :views="available_views(is_mobile,views_props)"
    :is_mobile="is_mobile"
    :title="title"
    hide_add_button
    @update="update_filters"
  />
</template>


<style lang="scss">
  @import "@/sass/explorer.scss";
</style>
  
  
<script>
  import { mapState, mapActions, mapGetters } from 'vuex'
  import ExplorerDirectory from '@/components/explorer/ExplorerDirectory'
  import GenericExplorer from '@/components/explorer/GenericExplorer'
  import QUnitCollection from '@/qunit/QUnitCollection'
  import ChartsAPI from '@/api/ChartsAPI';
  import { QFilters, url_to_filters } from '@/qunit/filters';
  
  export default {
    name: 'TodoExplorerView',
  
    components: {
      GenericExplorer,
      ExplorerDirectory,
    },
 
    data: () => ({
      title: 'TODO LIST',
      filters: new QFilters(),
      props: {
          'ExplorerTable': {
            'selectable': true,
            'actions': true,
            'server_pagination': true,
            'navigate': true,
            'function': QUnitCollection.todoList,
            'filter_list': [
              'FilterCentro',
              'FilterProcess',
              'FilterUser',
              'FilterSearch',
              'FilterDatesRange',
            ],
          },
          'ExplorerCalendar': {
            'actions': true,
            'function': QUnitCollection.todoCalendar,
            'filter_list': [
              'FilterCentro',
              'FilterProcess',
              'FilterUser',
              'FilterSearch',
            ],
            action_list: [
              'ActionTransitions',
              'ActionViewQUnit',
              'ActionShowContacts',
              'ActionDownloadEvidence',
              'ActionDownloadCurrent',
              'ActionViewReports',
              'ActionNavigate',
            ],
          },
          'ExplorerCard': {
            'actions': true,
            'function': QUnitCollection.todoList,
            'filter_list': [
              'FilterCentro',
              'FilterProcess',
              'FilterUser',
              'FilterSearch',
              'FilterDatesRange',
            ],
          },
        },
    }),
  
    computed: {
      ...mapGetters(['centro_id','user']),
      ...mapState(['todolist_filters','bpmap','is_mobile']),

      views_props() {
        let props =  this.props;
        props['ExplorerTable'].expandable = !this.is_mobile;
        return props;
      },
    },
 
    mounted() {
      this.populate_filters();
    },
 
    methods: {
      ...mapActions(['SET_EXPLORER_FILTERS']),
 
      populate_filters() {
        this.filters = url_to_filters({
          ...this.$route.query,
          centro: this.centro_id,
          current_workflow_responsible: this.user.id,
        });
      },

      update_filters(ef) {
        this.SET_EXPLORER_FILTERS(ef);
      },

      available_views(is_mobile,props) {
        let views = [{name: 'ExplorerTable',...props['ExplorerTable']}];
        
        if (is_mobile) {
          views.push({name: 'ExplorerCard',...props['ExplorerCard']});
        }
        views.push({name: 'ExplorerCalendar',...props['ExplorerCalendar']});
        if ((this.bpmap.get_value(this.filters.get_filter_value('business_process'))||{}).has_charts) {
          views.push({name: 'ExplorerCharts',...props['ExplorerCharts']});
        }
       return views;
      },

      // Charts method
      async chart_update(filters) {
        return await ChartsAPI.view(
          (filters.get_filter_value('site') || '').split('/').at(-1), // TODO: Update when site is no longer a path
          filters
        )/*.then((data)=> {
          this.props['ExplorerCharts'].charts = data;
          this.props = {...this.props}
        });*/
      },
    },
  
    watch: {
      '$route': function() {
        this.populate_filters();
      },
  
      '$route.query.business_process': {
        handler() {
          /* this.populate_filters(); */
        },
        deep: true,
        immediate: true,
      },
    },
  }
</script>
